export default "__VITE_ASSET__DDG1HSrw__"